// Shared reactive store for live C = (P×M×E×R×I)/N consciousness state
// Written by KarmaDynamicIsland, read by MindalooStarfield, KarmaCommandBar, etc.

type Listener = (score: number) => void;

class ConsciousnessStore {
  private _score = 35;
  private _listeners: Set<Listener> = new Set();

  get score() { return this._score; }

  set(score: number) {
    this._score = Math.max(0, Math.min(100, score));
    this._listeners.forEach(l => l(this._score));
  }

  subscribe(fn: Listener): () => void {
    this._listeners.add(fn);
    fn(this._score);
    return () => this._listeners.delete(fn);
  }
}

export const consciousnessStore = new ConsciousnessStore();
